import { Gavel } from "@mui/icons-material";
import {
  Box,
  Container,
  Link as MuiLink,
  Stack,
  Typography,
} from "@mui/material";
import type { NavbarHeaderRenderProps } from "@ssf/auth-components";
import { useAuth } from "@ssf/auth-components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { generatePath } from "../lib";
import { Search } from "./index.js";

export const Header = ({ collapsed }: NavbarHeaderRenderProps) => {
  const { t } = useTranslation("Header");
  const { isFedAdmin } = useAuth();

  if (!collapsed && !isFedAdmin) return null;

  return (
    <Container sx={{ maxWidth: "100% !important" }}>
      <Stack
        spacing={1}
        direction="row"
        sx={{
          alignItems: "center",
          minHeight: 48,
        }}
      >
        <MuiLink
          component={Link}
          to={generatePath("selectClub", {})}
          sx={{
            mr: "auto",
            svg: { width: 32, mr: 0.5, mt: -0.5 },
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
          }}
        >
          <Gavel />
          <Typography component="h1" variant="h4">
            {t("title")}
          </Typography>
        </MuiLink>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
          }}
        >
          {isFedAdmin && <Search />}
        </Box>
      </Stack>
    </Container>
  );
};
